import { render, staticRenderFns } from "./modalCadastroTomador.vue?vue&type=template&id=14c5f965"
import script from "./modalCadastroTomador.vue?vue&type=script&lang=js"
export * from "./modalCadastroTomador.vue?vue&type=script&lang=js"
import style0 from "./modalCadastroTomador.vue?vue&type=style&index=0&id=14c5f965&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports